import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IClaimCodeMaster } from 'src/app/models/IClaimCodeMaster';
import { IClinicTimeZone } from 'src/app/models/IClinicTimeZone';
import { IAttributes } from 'src/app/models/IAttributes';
import { ITimeZoneList } from 'src/app/models/ITimeZoneList';
import { IMasterRooms } from 'src/app/models/IMasterRooms';
import { configuration } from 'src/environments/environment';
import { IHolidays, IInpatient, IIntervention } from 'src/app/models/IHolidays';
import { IORTimeLines } from 'src/app/models/IORTimeLines';
import { IReferralDetails } from 'src/app/models/IReferralDetails';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  constructor(private http: HttpClient) { }

  // Get all time zones
  getTimeZones(): Observable<ITimeZoneList[]> {
    return this.http.get<ITimeZoneList[]>(`${configuration.apiUrl + 'Master/Locations'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Get all financial centers
  getFinancialCenters(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/FinancialCenters'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  // Add location 
  addLocationInfo(locationDetailsInfo: IClinicTimeZone): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/ClinicLocation'}`, locationDetailsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get locations by facility id
  getLocations(): Observable<IClinicTimeZone[]> {
    return this.http.get<IClinicTimeZone[]>(`${configuration.apiUrl + 'Master/LocationInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getORTimeLineLocations(): Observable<IClinicTimeZone[]> {
    return this.http.get<IClinicTimeZone[]>(`${configuration.apiUrl + 'Master/LocationInfoORTimeLine'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Add location 
  updateLocationStatus(locationDetailsInfo: IClinicTimeZone): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/LocationStatus'}`, locationDetailsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  addRoomsInfo(roomsInfo: IMasterRooms): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/Rooms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, roomsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get rooms by facility id
  getRooms(locationId: number): Observable<IMasterRooms[]> {
    return this.http.get<IMasterRooms[]>(`${configuration.apiUrl + 'Master/Rooms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${locationId}`);
  }

  // Add rooms 
  // updateRooms(roomsInfo: IMasterRooms): Observable<string> {
  //   return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdateRooms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, roomsInfo, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  updateRooms(roomsInfo: IMasterRooms): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(roomsInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdateRooms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // addORTimeLineInfo(inst: IORTimeLines): Observable<string> {
  //   return this.http.post<string>(`${configuration.apiUrl + 'Master/OrRecordTimeLines'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, inst, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  addORTimeLineInfo(inst: IORTimeLines): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(inst)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/OrRecordTimeLines'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get OR Time Lines by facility id
  getORTimeLineInfo(locationId: number): Observable<IORTimeLines> {
    const posteddata = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      locationId: locationId
    }
    return this.http.post<IORTimeLines>(`${configuration.apiUrl + 'Master/getOrRecordTimeLines'}`, posteddata);
  }

  // Get OR Time Lines by facility id
  getAllORTimeLineInfo(): Observable<IORTimeLines[]> {
    return this.http.get<IORTimeLines[]>(`${configuration.apiUrl + 'Master/OrRecordTimeLines'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${Number(sessionStorage.getItem("FacilityId"))}`);
  }

  insertHolidaysDetails(clinicholidays: IHolidays): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/ClinicHolidays'}`, clinicholidays, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }

  getHolidaysdetails(): Observable<IHolidays[]> {
    return this.http.get<IHolidays[]>(`${configuration.apiUrl + 'Master/ClinicHolidays'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  deleteHolidaysDetails(clinicholidays: IHolidays): any {
    return this.http.post<any>(`${configuration.apiUrl + 'Master/UpdClinicHolidays'}`, clinicholidays, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateHolidaysDetails(clinicholidays: IHolidays): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdClinicHolidays'}`, clinicholidays, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //*****  Get Admin --Master  locations by facility id */ 
  adminMasterAllLocations(): Observable<IClinicTimeZone[]> {
    return this.http.get<IClinicTimeZone[]>(`${configuration.apiUrl + 'Master/AdminMasterLocationInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  insertUpdateVitalTimeLine(type: string, timeline: Number): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/VitalTimeLine'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${Number(sessionStorage.getItem("FacilityId"))}&&locationId=${Number(sessionStorage.getItem("LocationId"))}&&type=${type}&&TimeLine=${timeline}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //*****  Get Admin --Master  locations by facility id */ 
  getReferalProvidersInfo(): Observable<IReferralDetails[]> {
    return this.http.get<IReferralDetails[]>(`${configuration.apiUrl + 'Patient/ReferralProviders'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
  insertUpdateReferringProviders(saveObject: IReferralDetails): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(saveObject)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Patient/InsertPCPReferringProviders'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getReferringProvidersCount(lastName: string, firstName: string, middleName: string, NPI: string, referralInformationId: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Patient/GetAllReferringProvidersCount'}?lastName=${lastName}&&firastName=${firstName}&&middleName=${middleName}&&npi=${NPI}&&referralMasterId=${referralInformationId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeleteReferringProviderBySelectedId(ReferralInformationId: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Patient/DeletePCPReferringProviders'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&referralInformationId=${ReferralInformationId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //*****Update Admin Configuration */

  UpdateAdminConfiguration(AutoLogoffInterval): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/AutoLogoffInterval'}?autoLogoffInfo=${AutoLogoffInterval}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAutoLOgoffInterval(facilityid: string, userid: string): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Admin/AutoLogoffInterval'}?facilityId=${facilityid}&&userid=${userid}`
      , {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
        // headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
      });
  }

  insertInterventionDetails(Intervention: IIntervention): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(Intervention)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/InsertUpdateDeleteIntervention'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }

  getInterventiondetails(Encid: string): Observable<IIntervention[]> {
    return this.http.get<IIntervention[]>(`${configuration.apiUrl + 'Master/getIntervention'}?EncId=${Encid}`);
  }


  InsertInpatient(Inpatient: IInpatient): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(Inpatient)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/InsertInpatient'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }

  GetInpatient(Encid: string): Observable<IInpatient[]> {
    return this.http.get<IInpatient[]>(`${configuration.apiUrl + 'Master/getInpatient'}?EncId=${Encid}`);
  }

  DeleteInpatient(id: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/DeleteInpatient'}?id=${id}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
